import React, { useEffect, useRef, useState } from "react";
import "./guestViewerWrapper.scss";
import { useParams } from "react-router-dom";
import { AuthReducerProps } from "../../../store/reducers/authReducer";

interface GuestViewerWrapperProps extends AuthReducerProps {}

function GuestViewerWrapper({ userRole }: GuestViewerWrapperProps) {
  const { caseId }: any = useParams();

  const [downloadZip, setDownloadZip] = useState(false);

  const iframeRef = useRef<HTMLIFrameElement>(null);

  const url: string | undefined = process.env.REACT_APP_VIEWER_BASE_URL ?? "";

  const authToken = localStorage.getItem("Authorization") || null;

  useEffect(() => {
    const downloadZip = localStorage.getItem("download_zip") === "true";
    setDownloadZip(downloadZip);
    localStorage.removeItem("download_zip");
  }, []);

  return (
    <div className={`viewer-wrapper viewer-wrapper--guest`}>
      <div className="viewer-wrapper__iframe-wrapper">
        <iframe
          ref={iframeRef}
          src={`${url}?caseId=${caseId}&authToken=${encodeURIComponent(
            authToken || ""
          )}&guest=true&downloadZip=${downloadZip}`}
          title="Case viewer"
          className="viewer-wrapper__iframe"
          allow="clipboard-write; clipboard-read"
        />
      </div>
    </div>
  );
}

export default GuestViewerWrapper;
